<template>
  <div>
    <h1>{{ $t("tripPolicy.title") }}</h1>

    <DelegationInfoMenu></DelegationInfoMenu>

    <v-row
      ><h2>{{ title }}</h2>
      <v-spacer></v-spacer>
      <v-btn to="/settings/custom-webpage" class="accent" v-if="canEdit"
        >{{ $t("global.edit") }}
        <v-icon>border_color</v-icon>
      </v-btn>
    </v-row>

    <div class="ql-container ql-snow" style="border: none">
      <div v-html="html" class="ql-editor"></div>
    </div>
    <multiple-file-download :files="files" @download="fileId => download(fileId)" />
  </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import DelegationInfoMenu from "../../components/DelegationInfoMenu.vue";
import downloadFile from "../../repository/downloadFile";
import MultipleFileDownload from "../../components/MultipleFileDownload";

export default {
  name: "DelegationInfoTripPolicyView",
  components: { MultipleFileDownload, DelegationInfoMenu },
  data: () => ({
    html: "",
    title: "",
    files: []
  }),
  watch: {
    "$route.params"() {
      this.downloadWebpage();
    }
  },
  methods: {
    downloadWebpage() {
      this.axios.get("custom-webpage/get", { params: { alias: this.$route.params.alias } }).then(response => {
        this.title = response.data.title;
        this.html = response.data.content;
        this.files = response.data.files;
      });
    },
    download(fileId) {
      downloadFile("custom-webpage/get-file?fileId=" + fileId);
    }
  },
  computed: {
    canEdit() {
      return this.$store.getters.hasPermission("manageWebPages");
    }
  },
  created() {
    this.downloadWebpage();
  }
};
</script>

<style scoped></style>
